import { render, staticRenderFns } from "./MediaMTX.vue?vue&type=template&id=5846bcc4&scoped=true&"
import script from "./MediaMTX.vue?vue&type=script&lang=js&"
export * from "./MediaMTX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5846bcc4",
  null
  
)

export default component.exports